const middleware = {}

middleware['authenticated'] = require('../middleware/authenticated.js')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['authenticateUser'] = require('../middleware/authenticateUser.js')
middleware['authenticateUser'] = middleware['authenticateUser'].default || middleware['authenticateUser']

middleware['check-source'] = require('../middleware/check-source.js')
middleware['check-source'] = middleware['check-source'].default || middleware['check-source']

middleware['detected-country'] = require('../middleware/detected-country.js')
middleware['detected-country'] = middleware['detected-country'].default || middleware['detected-country']

middleware['fix-double-slash'] = require('../middleware/fix-double-slash.js')
middleware['fix-double-slash'] = middleware['fix-double-slash'].default || middleware['fix-double-slash']

export default middleware
